export const QUANTITIES_BY_SUPPLIER = 'QuantitiesBySupplier'

export default {
  QuantitiesCombined: 'quantitiesCombined',
  QuantitiesBySupplier: 'quantitiesBySupplier',
}
